export { default as MuxVideo } from '@/components/ui/MuxVideo/MuxVideo';
